import { Box, Paper, Skeleton, Stack } from '@mui/material';
import { filterItemSx } from './ordering-table-filters.styles';

// Mirrors OrderingTableFilters' own layout - a label bar over a control bar, several side by side.
const placeholderCount = 4;

export default function OrderingTableFiltersSkeleton() {
    return (
        <Paper variant="outlined" sx={{ p: 2, mb: 2, borderRadius: 2 }}>
            <Stack direction="row" flexWrap="wrap" alignItems="flex-start" sx={{ gap: 2 }}>
                {[...Array(placeholderCount)].map((_, index) => (
                    <Box key={index} sx={filterItemSx}>
                        <Skeleton variant="text" width="60%" height={20} sx={{ mb: 0.75 }} />
                        <Skeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: 1 }} />
                    </Box>
                ))}
            </Stack>
        </Paper>
    );
}
